module.exports = __webpack_public_path__ + "static/media/icon-tools-white.96fa0b1d.svg";